import { GlobalContext } from "@utils/GlobalContext.js";
import { useContext } from "react";

export default function PhotoCarousel() {
    const { photos, setSeeModal } = useContext(GlobalContext);
    return (
        <div id="photoCarousel" className="carousel slide position-relative">
            <i className="close-modal fa-solid fa-xmark fs-1" onClick={() => setSeeModal(false)}></i>
            <div className="carousel-inner">
                {photos.map((photo: string, index: number) => (
                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                        <img src={photo} className=" w-100" alt={`Photo ${index + 1}`} />
                    </div>
                ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#photoCarousel" data-bs-slide="prev">          
                <i className="fa-solid fa-angle-left hst-carusel-arrow-left" ></i>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#photoCarousel" data-bs-slide="next">
                 <i className="fa-solid fa-angle-right hst-carusel-arrow-right"></i>
            </button> 
        </div>

    );
}